import React, { useEffect, useState } from 'react'

import { useFormik } from 'formik'
import * as yup from 'yup'

import * as S from './styles'
import Table from '../../../shared/components/Table'
import { resetForm } from '../../../utils/form-utils'
import { isEqual } from 'lodash'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'

type Props = {
  selectedOpme: any[]
  setSelectedOpme: (opme: any) => void
  handleChange: (field: string[]) => any
  onlyVisualization?: boolean
  defaultProviders?: string[]
  favoriteProviders?: string[]
}

export const OpmeTable = ({
  selectedOpme,
  setSelectedOpme,
  handleChange,
  onlyVisualization,
  defaultProviders,
  favoriteProviders
}: Props) => {
  const [providers, setProviders] = useState<string[]>(
    favoriteProviders! && favoriteProviders.length > 0
      ? favoriteProviders
      : defaultProviders
      ? defaultProviders
      : ['', '', '']
  )

  const formik = useFormik({
    initialValues: {
      quantity: 1,
      description: ''
    },
    validateOnMount: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setSelectedOpme([
        ...selectedOpme,
        {
          description: values.description,
          quantity: Number(values.quantity)
        }
      ])
      resetForm(formik)
    }
  })

  const onDeleteRow = (index: number[]) => {
    setSelectedOpme(
      selectedOpme.filter(
        (procedure, procedureIndex) => !index.includes(procedureIndex)
      )
    )
  }

  const handleProvidersChange = (val: string, index: number) => {
    const newProviders = [...providers]
    newProviders[index] = val
    setProviders(newProviders)
  }

  const removeProvider = (index: number) => {
    const newProviders = [...providers]
    newProviders.splice(index, 1)
    setProviders(newProviders)
  }

  useEffect(() => {
    handleChange(providers)
  }, [providers])

  return (
    <S.Wrapper>
      {!onlyVisualization && (
        <>
          <S.Inputs>
            <TextFieldNew
              placeholder="Descrição"
              onInputChange={formik.handleChange('description')}
              value={formik.values.description}
              style={{ width: '100%' }}
              data-testid={`opme-description-input`}
            />
            <S.QuantityContainer>
              <S.Title>Quantidade</S.Title>
              <TextFieldNew
                onInputChange={formik.handleChange('quantity')}
                value={formik.values.quantity}
                type="number"
                data-testid={`opme-quantity-input`}
              />
            </S.QuantityContainer>

            <ButtonNew
              size="large"
              type="button"
              onClick={formik.submitForm}
              disabled={!formik.isValid}
              data-testid={`add-opme-button`}
              style={{ width: 120 }}
            >
              <span style={{ color: '#fff' }}>Adicionar</span>
            </ButtonNew>
          </S.Inputs>
        </>
      )}
      <Table
        style={{ maxHeight: '180px', marginTop: '0px', marginBottom: '20px' }}
        checkbox={!onlyVisualization}
        data={selectedOpme.map((opme) => {
          return {
            ...opme,
            description:
              opme.description === '99882'
                ? 'Atendimento com OPME'
                : opme.description
          }
        })}
        columns={columns}
        rowsDelete={onDeleteRow}
        pagination={false}
      />
      <S.Providers>
        <div
          style={{
            maxHeight: '165px',
            display: 'flex',
            flexWrap: 'wrap',
            overflow: 'scroll',
            gap: '15px',
            position: 'relative'
          }}
        >
          {providers.map((provider: any, index) => (
            <>
              <div style={{ display: 'flex' }}>
                <TextFieldNew
                  label={`Fornecedor ${index + 1}`}
                  key={index + 1}
                  onInputChange={(val) => handleProvidersChange(val, index)}
                  disabled={onlyVisualization}
                  value={provider.description || provider}
                  required={index === 0}
                  data-testid={`provider-${index}-input`}
                />
                {!onlyVisualization && (
                  <S.RemoveProviderIcon
                    style={{ marginTop: '35px', marginLeft: '10px' }}
                    data-testid={`provider-${index}-delete-icon`}
                    onClick={() => removeProvider(index)}
                  />
                )}
              </div>
            </>
          ))}
        </div>
        {!onlyVisualization && (
          <S.AddProviderWrapper
            onClick={() => setProviders([...providers, ''])}
            data-testid={`add-provider-button`}
          >
            <S.AddProviderIcon />
            <p>Adicionar fornecedor</p>
          </S.AddProviderWrapper>
        )}
      </S.Providers>
    </S.Wrapper>
  )
}

const columns = [
  {
    label: 'Descrição',
    name: 'description',
    options: {
      sort: false
    }
  },
  {
    label: 'Quantidade',
    name: 'quantity',
    options: {
      sort: false
    }
  }
]

const validationSchema = yup.object().shape({
  quantity: yup.number().min(1),
  description: yup.string().required()
})

function dataCompare(prevData: Props, nextData: Props) {
  const prev = {
    opmes: prevData.selectedOpme
  }

  const next = {
    opmes: nextData.selectedOpme
  }

  return isEqual(prev, next)
}

export default React.memo(OpmeTable, dataCompare)
